import { Alert, Snackbar } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getSnackbarMessage, setSnackbarMessage } from '../redux/snackbarMessageSlice';

function CustomizedSnackbar() {
    const snackbarMessage = useSelector(getSnackbarMessage);
    const dispatch = useDispatch();

    const handleClose = (event, reason) => {
        // if (reason === 'clickaway') {
        //     return;
        // }
        dispatch(setSnackbarMessage({
            open: false,
            message: "",
            status: ''
        }));
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbarMessage.open}
                autoHideDuration={snackbarMessage.status === 'error' ? 3000 : 2000}
                onClose={handleClose}
            >
                <Alert
                    severity={snackbarMessage.status}
                    sx={{ width: '100%' }}
                >
                    {snackbarMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default CustomizedSnackbar